const TYPE = {
  CAMPAIGN_NORMAL: 11,
  RENTAL_NORMAL: 21,
  RENTAL_AMBASSADOR: 22,
}

const SEX = {
  FEMALE: 1,
  MALE: 2,
}

const STATUS = {
  STAT_JOIN_CD: 10,
  STAT_APPLY_CD: 20,
  STAT_MODEL_CD: 30,
  STAT_DROP_CD: 99,
}

const USER = {
  TYPE,
  SEX,
  STATUS,
}

export default USER
